<template>
    <div class="wrap_container">
        <slot></slot>
    </div>
</template>
<script lang="ts" setup>

</script>
<style lang="scss" scoped>
.wrap_container{
    position: relative;
    background-color: #fff;
    border-radius: 10px;
}
</style>